/**
 * Labstep
 *
 * @module components/EntityImport/EmptyState
 * @desc EntityImport Empty State
 */

import { EntityImportActionCreateTrigger } from 'labstep-web/components/EntityImport/Action/Create/Trigger';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Loadable } from 'labstep-web/core/Loadable';
import type { ExcelIOData } from 'labstep-web/services/excel-io/types';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import React, { useState } from 'react';
import type { EntityImportEmptyStateProps } from './types';

export const EntityImportActionCreate = React.lazy(() =>
  import('labstep-web/components/EntityImport/Action/Create').then(
    (module) => ({
      default: module.EntityImportActionCreateContainer,
    }),
  ),
);

export const EntityImportEmptyState: React.FC<
  EntityImportEmptyStateProps
> = ({ entityName, templateId }) => {
  const [importData, setImportData] = useState<
    ExcelIOData | undefined
  >();
  return (
    <Loadable>
      <EntityImportActionCreate
        entityName={entityName}
        templateId={templateId}
        importData={importData}
        setImportData={setImportData}
      />
      <EntityImportActionCreateTrigger
        entityName={entityName}
        allowImportOnly
        setImportData={setImportData}
        dropzoneProps={{
          noClick: true,
          showDragEnter: true,
          children: (
            <CardEmptyState
              src="/img/empty-state/file-to-cloud.svg"
              explanation={`Drag and Drop CSV /XLSX files to import ${getHumanReadableEntityName(
                entityName,
                true,
              )} in bulk`}
              action={
                <EntityImportActionCreateTrigger
                  entityName={entityName}
                  setImportData={setImportData}
                />
              }
            />
          ),
        }}
      />
    </Loadable>
  );
};
